import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'OptionValue',
    column_type: 'id',
    label_key_path: 'optionValue.id',
  },
  created_at: {
    model_name: 'OptionValue',
    column_type: 'datetime',
    label_key_path: 'optionValue.createdAt',
  },
  updated_at: {
    model_name: 'OptionValue',
    column_type: 'datetime',
    label_key_path: 'optionValue.updatedAt',
  },
  name: {
    model_name: 'OptionValue',
    column_type: 'string',
    label_key_path: 'optionValue.name',
  },
  option_type: {
    model_name: 'OptionValue',
    column_type: 'belongs_to',
    label_key_path: 'optionValue.optionType',
    extra: {
      association_name: 'option_type',
      model_name: 'OptionType',
      foreign_key: 'option_type_id',
      display_column: 'name',
    },
  },
  option_type_id: {
    model_name: 'OptionValue',
    column_type: 'belongs_to',
    label_key_path: 'optionValue.optionType',
    extra: {
      association_name: 'option_type',
      model_name: 'OptionType',
      foreign_key: 'option_type_id',
      display_column: 'name',
    },
  },
  position: {
    model_name: 'OptionValue',
    column_type: 'integer',
    label_key_path: 'optionValue.position',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
